export function splitPolicyId(policyId: string): string[] {
  const i = policyId.indexOf('-')
  return [policyId.substring(0, i), policyId.substring(i + 1)]
}
